import colors from "vuetify/lib/util/colors"

const hostname = window.location.hostname

export default {
  env: hostname.includes('localhost')
    ? colors.blueGrey
    : hostname.includes('stg')
      ? colors.green
      : '#2AA7CA'
}
